// Countdown text (Stratus v2's Countdown). The long form is Timers' (plan 1D), so
// Timers can swap to Countdown with no visible change: `1d 02:03:04`, `02:03:04`, and
// `00:00:00` once passed. Seconds are floored, so the clock never shows a second that
// hasn't started yet. The short form is relative: `in 3d`, `in 3h`, `in 12m`, `in 40s`.

const pad = (value: number): string => String(value).padStart(2, '0');

export type CountdownFormat = 'long' | 'short';

/** `ms` until the target, as text. Negative or zero is "passed". */
export function formatCountdown(ms: number, format: CountdownFormat = 'long'): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const days = Math.floor(total / 86_400);
  if (format === 'short') {
    if (days > 0) return `in ${String(days)}d`;
    if (total >= 3600) return `in ${String(Math.floor(total / 3600))}h`;
    if (total >= 60) return `in ${String(Math.floor(total / 60))}m`;
    return `in ${String(total)}s`;
  }
  const clock = `${pad(Math.floor((total % 86_400) / 3600))}:${pad(Math.floor((total % 3600) / 60))}:${pad(total % 60)}`;
  return days > 0 ? `${String(days)}d ${clock}` : clock;
}

/** A target as ms since the epoch: an ISO instant or a number. */
export function targetMs(target: string | number): number {
  return typeof target === 'number' ? target : new Date(target).getTime();
}
